module.exports = __webpack_public_path__ + "static/fpi1-hero-80d3254f319e3f970b77e5e299d13b5b.webp";